import { Container, Grid, styled } from "@mui/material"

export const MainContainer = styled(Container)(
  ({}) => `
  margin:30px 0;
`
)

export const TableContainer = styled(Grid)(
    ({theme}) => `
    background-color:${theme.palette.background.paper};
    // border:2px solid ${theme.palette.primary.main};
    border-radius:8px;
    box-shadow: -2px 2px 48px 0px rgba(0,0,0,0.40);
    -webkit-box-shadow: -2px 2px 48px 0px rgba(0,0,0,0.40);
    -moz-box-shadow: -2px 2px 48px 0px rgba(0,0,0,0.40);
  `
  )

  export const DatePickerContainer = styled(Grid)(
    ({}) => `
    & .rmdp-container{
      width:100%;
    }
  `
  )

  export const ButtonContainer = styled(Grid)(
    ({theme:{breakpoints}}) => `
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap:6px;

    & .small{
      width:50%;
    }

    ${[breakpoints.down("md")]}{
      & .small{
        width:100%;
      }
  }
  `
  )